import { render } from "./CooKie.vue?vue&type=template&id=02b0c827&ts=true"
import script from "./CooKie.vue?vue&type=script&lang=ts"
export * from "./CooKie.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__